/**
 * Minimalerei Megamenu — Hover-Open-Delay-Layer
 *
 * Erweitert Dawn's <details>-Click-Toggle um Hover-Open mit 200ms Delay.
 * Click-Verhalten bleibt unverändert (Dawn-Standard).
 * Touch-Devices: kein Hover, normale Click-Logic.
 */

(function () {
  'use strict';

  const HOVER_OPEN_DELAY = 200;
  const HOVER_CLOSE_DELAY = 500;

  function initHoverOpen() {
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(max-width: 768px)').matches) return;

    const headerMenus = document.querySelectorAll('header-menu');

    headerMenus.forEach(function (headerMenu) {
      const details = headerMenu.querySelector('details');
      if (!details) return;

      let openTimer = null;
      let closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        if (details.open) return;
        openTimer = setTimeout(function () {
          details.open = true;
          headerMenu.setAttribute('data-mp-hover-open', '');

          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }, HOVER_OPEN_DELAY);
      }

      function close() {
        clearTimeout(openTimer);
        if (!details.open) return;
        closeTimer = setTimeout(function () {
          details.open = false;
          headerMenu.removeAttribute('data-mp-hover-open');

          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, HOVER_CLOSE_DELAY);
      }

      headerMenu.addEventListener('mouseenter', open);
      headerMenu.addEventListener('mouseleave', close);

      // Auch direkt auf dem Megamenu-Content lauschen — fängt User ab,
      // die langsam vom Summary durch die Lücke nach unten ziehen.
      const menuContent = details.querySelector('.mega-menu__content');
      if (menuContent) {
        menuContent.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });
        menuContent.addEventListener('mouseleave', close);
      }

      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function () {
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
        });
      }
    });
  }

  // Click-to-Navigate: wenn ein Top-Level-Menü-Item (Summary) einen
  // data-mp-menu-url hat, navigiere bei normalem Click dorthin statt
  // das Details-Element zu togglen. Modifier-Clicks (Cmd/Ctrl/Shift/Alt
  // oder Middle-Click) bleiben unangetastet — der Browser handhabt
  // sie nativ (z.B. öffnet einen neuen Tab — funktioniert hier nicht,
  // da kein <a>-Tag, also einfach Toggle).
  function initClickToNavigate() {
    document.querySelectorAll('header-menu summary[data-mp-menu-url]').forEach(function (summary) {
      summary.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var url = summary.getAttribute('data-mp-menu-url');
        if (!url || url === '#') return;
        e.preventDefault();
        window.location.href = url;
      });
    });
  }

  function init() {
    initHoverOpen();
    initClickToNavigate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
